import React from 'react';

/**
 * Labelled Bootstrap checkbox.
 *
 * The Personal Data Sheet had no checkbox until the "same mailing address"
 * conveniences were added; this follows the FPR wizard's AutoCheckbox markup
 * so `.theme-rebellionaire`'s existing `.form-check-input` / `.form-check-label`
 * rules style it in both brands without new CSS.
 */
export default function CheckboxInput({
  id,
  label,
  checked,
  onChange,
  col,
  disabled = false,
}) {
  const control = (
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        id={id}
        checked={!!checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <label className="form-check-label small" htmlFor={id}>
        {label}
      </label>
    </div>
  );

  return col ? <div className={col}>{control}</div> : control;
}
